export const API_ENDPOINTS = {
	SSO_SIGN_IN: "/accounts/ssoSignIn",
	REFRESH_TOKEN: "/accounts/refresh",
	SSO_CALLBACK: "/accounts/ssoCallBack",
	USER_LOGOUT: "/accounts/logout",

	GET_NEWS_LIST: "/cms/get-news-list",
	REMOVE_NEWS: "/cms/remove-news",

	GET_DISCOVERY_LIST: "/cms/get-discovery-list",
	REMOVE_DISCOVERY: "/cms/remove-discovery",

	GET_EVENTS_LIST: "/cms/get-event-list",
	REMOVE_EVENTS: "/cms/remove-event",

	PROXY_USER: "/accounts/proxy-user",
	CHECK_ACCESS_TOKEN_VALIDITY: "/accounts/check-access-token-validity",
	FISCAL_YEAR_STATUS: "/fiscalYear/fiscalYearTermStatus",
	FISCAL_YEAR_STATUS_SEARCH: "/fiscal-year-terms/search",
	FISCAL_YEAR: "/fiscalYear",
	FISCAL_YEAR_DETAIL: "/fiscalYear/detail",
	FISCAL_YEAR_TERM_SEARCH: "/fiscal-year-terms/search",
	FISCAL_YEAR_SEARCH: "/fiscalYear/search",
	GET_FISCAL_YEAR: "/fiscalYear/pagedList",
	USER_LIST: "/users/list",
	COMPANY_SEARCH: "/companies/search",
	USER_INFO: "/users/user-info",
	USER_SEARCH: "/users/search",
	USER_ROLE_FILTER_SEARCH: "/users/rolefiltersearch",
	PROXY_UDY_SEARCH: "/users/proxy-udy-search",
	USER_UDY_LIST: "/users/udy-search",
	EMPLOYEE_UDY_LIST: "/users/employee-udy-search",
	USERS_WITH_ROLES: "/rolesManagement/getUsersWithRoles",
	ADMIN_ROLES: "/rolesManagement/getAdminRoles",
	ROLES_MANAGEMENT: "/rolesManagement",
	USER_FKEY_LIST: "/users/search",
	USER_PAYMENT_SUGGESTION: "/user-payment/get-user-payment-suggest",
	NOTIFICATION_LETTERS_BASE: "/NotificationLetters",
	NOTIFICATION_LETTERS_LIST: "/NotificationLetters/pagedlist",
	NOTIFICATION_LETTERS_STATUS: "/NotificationLetters/envelopeTypeEnumStatus",
	NOTIFICATION_LETTERS_ENEVELOPE_TYPE: "/NotificationLetters/envelopeTypeEnumStatus",
	NOTIFICATION_LETTERS_DETAIL: "NotificationLetters/detail",
	NOTIFICATION_TYPE: "/NotificationLetters/notification-type",
	CHECK_USER_CLAIMS: "/accounts/check-user-claims",
	MenuList:"/cms/get-menu-list",
	STATIC_IMAGE_LIST: "/api/Main/staticImageList",
	USER_PAYMENT_STATUS: "user-payment/envelopeTypeEnumStatus",
	USER_PAYMENT_STATUS_OPTIONS_ALL: "/user-payment/envelope-Type-Enum-Status-all",
	LETTER_OPTIONS: "user-payment/envelope-Type-Enum-Status",
	USER_PAYMENT: "user-payment",
	USER_PAYMENT_DETAIL: "user-payment/detail",
	USER_PAYMENT_USERS: "user-payment/users",
	GENERAL_PARAMETER_LIST: "common/general-parameter-fkey-list",
	LOCALIZATION: "common/localization-fkey-list",
	POSITION_LIST: "common/udy-position-fkey-list",
	MAIL_TEMPLATE_TYPE: "common/mail-template-fkey-list",
	HOMEPAGE: "common/home-fkey-list",
	SELECTED_GROUP_COMPANY_LIST: "common/selected-group-return-company-list",
	WAGE_AND_BONUS_DEFINITIONS_USER_SEARCH: "users/payment-bonus-udy-search",
	MAIL_DETAIL: "mail/detail",
	MAIL_SEARCH: "mail/search",
	MAIL: "mail",
	MAIL_MARK_AS_ACTIVE: "mail/mark-as-activate",
	MAIL_MARK_AS_CANCELED: "mail/mark-as-canceled",
	MAIL_SEND_SELECTED: "mail/send-email-selected",
	MAIL_SEND_ALL: "mail/send-email-all",
	MAIL_GENERETED_DETAIL: "mail/generated-email-detail",
	MAIL_UPDATE_GENERETED_DETAIL: "mail/update-generated-email",
	PAYMENT_SUGGESTION_DEFINITION: "/payment-suggestion-definition",
	PAYMENT_SUGGESTION_DEFINITION_LIST: "/payment-suggestion-definition/pagedlist",
	COMPANY_GROUP_LIST: "common/company-group-fkey-list",
	TERM_LIST: "/common/gm-term-fkey-list",
	REPORT_TERM_LIST: "report/term-fkey-list ",
	REPORT_TERM_WAGE_LIST: "report/term-wage-list",
	PAYMENT_BULK_UPDATE: "payment-suggestion-definition/bulk-update",
	COMPANY_GROUP: "company/{id}/group",
	PERIODIC_PAYMENT_AND_BONUS_REPORT: "/report/periodic-payment-and-bonus/search",
	PERIODIC_PAYMENT_REPORT_EXCEL: "report/periodic-payment-report-excel",
	PERIODIC_BONUS_REPORT_EXCEL: "report/periodic-bonus-report-excel",
	CHECK_GM_TERM: "user-payment/is-gm-term",
	LETTER_LANGUAGE_OPTIONS: "api/main/admin-app-language",
	EMPLOYEE_WAGE_REPORT: "report/employee-wage-report",
	EMPLOYEE_WAGE_REPORT_EXCEL: "report/employee-wage-report-excel",
};

export const NOT_FOUND_TEXT = "Uygun Sonuç Bulunamadı";

export const API_KEY_HEADER = "x-Api-Key";
export const API_KEY = "yLnaRQj9hycxEyQEX4cVOPrfxAg5bZAx7jYI+jJc/dE=";

export const LANGUAGE_HEADER = "Accept-Language";
export const LANGUAGE = "tr-TR";